import React, { useMemo } from "react";
import "./FisheriesChart.scss";
import { Bar } from "react-chartjs-2";
import utils from "../../../../helpers/utils";
import FisheriesConfig from "../FisheriesConfig";

function FisheriesChart(props) {
  const { stats, selectedStat, handleChartClick } = props;

  // const country = utils.getCountryAttrForSelectedGeometry(selectedGeometry);

  const activeStat = stats.find((s) => s.id === selectedStat);

  /**
   * Build and memoize data in format expected by chart.js. Updates based on use selections for geo, stat, chart bar, and beach (eg. stats are updated)
   */
  const data = useMemo(() => {
    const bars = {
      datasets: activeStat?.chart.datasets,
      // [
      //   {
      //     data: [],
      //     label: "",
      //     backgroundColor: "#22497a",
      //   },
      // ],
    };

    // if (activeStat?.chart.type === "stacked") {
    //   bars.datasets.push({
    //     data: [],
    //     label: "",
    //     backgroundColor: "#227a52",
    //   });
    // }

    switch (activeStat?.short) {
      case "pressure":
        bars.datasets[0].label = "";
        break;
      case "curStock":
      case "potenStock":
        if (activeStat?.chart.type === "stacked") {
          bars.datasets[0].label = " snapper and grouper g/m²";
          bars.datasets[1].label = " parrotfishes g/m²";
        } else {
          bars.datasets[0].label = " g/m²";
        }
        break;
      case "predStock":
        bars.datasets[0].label = "%";
        break;
      case "predTime":
        bars.datasets[0].label = " Years";
        break;
    }

    bars.labels = FisheriesConfig.countries;

    if (activeStat?.chart.type === "stacked") {
      //hard coding for now
      const stackedStats = stats.filter(
        (s) => s.short === activeStat.short && s.id !== activeStat.id
      );

      stackedStats.forEach(
        (stackStat, n) =>
          (bars.datasets[n].data = FisheriesConfig.countries.map((country) => {
            const field = utils.getCountryAttrForSelectedGeometry(country);
            return Number(
              stackStat[field].toString().replace(/[^0-9.-]+/g, "")
            );
          }))
      );
    } else if (bars.datasets && bars.datasets.length) {
      bars.datasets[0].data = FisheriesConfig.countries.map((country) => {
        const field = utils.getCountryAttrForSelectedGeometry(country);
        return Number(activeStat[field].toString().replace(/[^0-9.-]+/g, ""));
      });
    }

    return bars;
  }, [activeStat, stats]);

  /**
   * Update which bar is clicked based on index
   */
  const elementClicked = (elements) => {
    if (elements.length && elements[0]) {
      handleChartClick(elements[0]._model.label);
    }
  };

  /**
   * Memoized bar chart options based on selected stat
   */
  const barOptions = useMemo(() => {
    const options = {
      fontColor: "black",
      scales: {
        xAxes: [
          {
            stacked: activeStat.chart.type === "stacked",
          },
        ],
        yAxes: [
          {
            stacked: activeStat.chart.type === "stacked",
            //beginAtZero: true,
            scaleLabel: {
              display: true,
              fontColor: "black",
            },
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          },
        ],
      },
      tooltips: {
        intersect: false,
        axis: "xy",
        mode: "index",
      },
      legend: {
        display: activeStat.chart.type === "stacked",
      },
      responsive: true,
      maintainAspectRatio: true,
      title: {
        display: true,
        text: selectedStat,
      },
      onHover: (event, chartElement) => {
        event.target.style.cursor = chartElement[0] ? "pointer" : "default";
      },
    };

    options.tooltips = {
      callbacks: {
        label: (tooltipItem, data) => {
          let label =
            tooltipItem.value + data.datasets[tooltipItem.datasetIndex].label;
          return label;
        },
      },
    };

    //hard coded labels
    switch (activeStat?.short) {
      case "pressure":
        options.scales.yAxes[0].scaleLabel.labelString = "";
        break;
      case "potenStock":
      case "curStock":
        options.scales.yAxes[0].scaleLabel.labelString = "g/m²";
        break;
      case "predStock":
        options.scales.yAxes[0].scaleLabel.labelString = "%";
        break;
      case "predTime":
        options.scales.yAxes[0].scaleLabel.labelString = "Years";
        break;
    }

    return options;
  }, [activeStat, selectedStat]);

  return (
    <div className="fisheriesChart">
      <Bar
        height={300}
        data={data}
        options={barOptions}
        onElementsClick={elementClicked}
      />
    </div>
  );
}

export default FisheriesChart;
